<div class="box">
  @if (!!title) {
  <h2>
    <span>{{ title }}</span>
    @if (differencesAccepted) {
    <span class="accepted">(Differences accepted)</span>
    }
  </h2>
  }
  <table>
    <tr>
      <td>Name:</td>
      <td>{{ file.FileName}}</td>
    </tr>
    <tr>
      <td>Content type:</td>
      <td><span [attr.style]="hiliteContentType() ? 'background-color: ' + color +';' : null">{{ file.ContentType}}</span></td>
    </tr>
    <tr>
      <td>Encoding:</td>
      <td><span [attr.style]="hiliteEncoding() ? 'background-color: ' + color +';' : null">{{ file.Encoding}}</span></td>
    </tr>
    <tr>
      <td>Byte-order-mark:</td>
      <td><span [attr.style]="hiliteBomPresent() ? 'background-color: ' + color +';' : null">{{ file.BomPresent ? 'Present' : 'Not present' }}</span></td>
    </tr>
    <tr>
      <td>Size:</td>
      <td><span [attr.style]="hiliteContentLength() ? 'background-color: ' + color +';' : null">{{ file.ContentSize }}</span> characters</td>
    </tr>
  </table>
</div>
